export type Notification = {
  id: string;
  agents_id: number;
  broadcast: boolean;
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'error' | 'agent';
  company_id: string;
  created_at: number;
  entity_id: string;
  entity_type: string;
  source_type: string;
  updated_at: number;
  user_id: string;
  persistent?: boolean;
  targetURL: string;
};

export const NotificationsStatusFilter = {
  UNREAD: 'unread',
  READ: 'read',
  CLEARED: 'cleared',
} as const;
export type NotificationsStatusFilter =
  (typeof NotificationsStatusFilter)[keyof typeof NotificationsStatusFilter];

export const NotificationsUpdateStatus = {
  READ: 'read',
  CLEAR: 'clear',
} as const;
export type NotificationsUpdateStatus =
  (typeof NotificationsUpdateStatus)[keyof typeof NotificationsUpdateStatus];

export type BaseNotification = Omit<Notification, 'type'> & {
  type: Exclude<Notification['type'], 'agent'>;
};

export const BaseNotificationType: Record<
  string,
  Exclude<Notification['type'], 'agent'>
> = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
} as const;
export type BaseNotificationType =
  (typeof BaseNotificationType)[keyof typeof BaseNotificationType];

export type NotificationData = {
  items: BaseNotification[];
  pagination: {
    curPage: number;
    itemsReceived: number;
    itemsTotal: number;
    nextPage: number;
    offset: number;
    pageTotal: number;
    perPage: number;
    prevPage: number;
  };
};
